module.exports = __webpack_public_path__ + "35163624e206a64bc5f088a88f5d84c7.jpg";